import { makeStyles } from 'tss-react/mui'
import _colors from 'styles/global/_colors'

export const useStyles = makeStyles()((theme) => ({
  mainContainer: {
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 1px 5px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24)',
    position: 'sticky',
    top: '0',
  },
  emailContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 250px)',
    boxShadow: '0 1px 5px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24)',
    top: '0',
    borderRadius: '4px',
    '& ::-webkit-scrollbar': { width: '8px' },
    '& ::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.00)',
    },
    '& ::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: '20px',
    },
  },
  emailContentBox: {
    position: 'relative',
    overflow: 'auto',
    padding: '0px 24px 0px 24px',
  },
  footerContainer: {
    display: 'flex',
    flexDirection: 'row',
    boxShadow: '0 1px 5px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.24)',
    position: 'sticky',
    top: '0',
    gap: '20px',
    height: '70px',
    padding: '12px 12px',
    borderRadius: '4px',
    '& ::-webkit-scrollbar': { width: '8px' },
    '& ::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.00)',
    },
    '& ::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: '20px',
    },
  },
  templateId: {
    color: '#000',
    fontFamily: 'HP Simplified',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  dealEndDate: {
    color: '#000',
    fontFamily: 'HP Simplified',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  title: {
    color: '#0096D6',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    letterSpacing: '0.15px',
    padding: '4px 0',
    paddingLeft: '16px',
    background: ' linear-gradient(89.96deg, #F7F7F7 64.43%, rgba(196, 196, 196, 0) 106.93%)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      paddingLeft: '10px',
    },
  },
  content: {
    display: 'flex',
    padding: '20px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '15px',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '20px',
    width: '100%',
  },
  error: {
    display: 'flex',
    marginTop: theme.spacing(2),
    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${_colors.red}`,
    color: _colors.redDark,
    border: `1px solid ${_colors.red}`,
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
    maxWidth: 'fit-content',
    whiteSpace: 'nowrap',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '16px',
  },
  primaryButton: {
    padding: '8px 22px 8px 22px',
    width: '156px',
    height: '42px',
    color: 'rgba(255, 255, 255, 1)',
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '26px',
    letterSpacing: '0.46px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '12px',
      padding: '4px 18px',
      height: '30px',
    },
  },
  secondaryButton: {
    padding: '8px 22px 8px 22px',
    width: '156px',
    height: '42px',
    color: '#0096D6',
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '26px',
    letterSpacing: '0.46px',
    border: '0.75px solid #80CBEB',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '12px',
      padding: '4px 18px',
      height: '30px',
    },
  },
  manageBackupLink: {
    textDecoration: 'underline',
    fontSize: '12px',
    color: '#0096D6',
    marginBottom: '16px',
    padding: '6px 0',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  link: {
    textDecoration: 'none',
    fontSize: '12px',
    padding: '4px 0px 0px 0px',
    color: '#0096D6',
    fontWeight: '400',
    background: 'none',
    border: 'none',
    font: 'inherit',
    cursor: 'pointer',
    '&:focus-visible': {
      outline: '2px solid #0096D6',
      outlineOffset: '2px',
    },
  },
  textField: {
    '& .MuiInputBase-input': {
      fontSize: '16px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },
  },
}))
